"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setItemsReplacementDetails = void 0;
const typesafe_actions_1 = require("typesafe-actions");
const consts_1 = require("./consts");
// eslint-disable-next-line import/prefer-default-export
exports.setItemsReplacementDetails = (0, typesafe_actions_1.createAction)(consts_1.SET_ITEMS_REPLACEMENT_DETAILS)();
